import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALE_STORAGE_KEY } from './config';

export function useSyncLocale(lang) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    localStorage.setItem(LOCALE_STORAGE_KEY, lang);
  }, [lang, i18n]);
}
